import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { LazyService } from '../../services/lazy.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { UtilService } from '../../services/util.service';
import { AppService } from '../../shared/services/app.service';
import { DialogRef } from '../dialog/dialog-ref';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { take } from 'rxjs/operators';
import { PreferenceService } from '../../shared/services/preference.service';
declare var Html5Qrcode: any;

@Component({
    selector: 'app-qr-code-scanner',
    templateUrl: './qr-code-scanner.component.html',
    styleUrls: ['./qr-code-scanner.component.scss'],
    standalone: false
})
export class QrCodeScannerComponent implements OnInit, AfterViewInit, OnDestroy {
  html5QrcodeScanner: any; showCameraPopUp: boolean = false;
  device: any; _loadedLibraries: any = {};
  barcode: any; physical_scaaner: boolean = true;
  @ViewChild("autofocusvalue") private _inputElement: ElementRef;
  placeholderValue: any = ""; listOfCameras=<any>[];
  facingModeIndex:number=0;

  constructor(
    private util: UtilService,
    private alert: AlertsService,
    private dialog: DialogRef,
    private loader: LoaderService,
    private _lazy: LazyService,
    private appService: AppService,
    private preferenceService: PreferenceService,
    private translate: TranslatePipe
  ) { }

  ngAfterViewInit() {
    this.checkscannerStatus();
  }

  checkscannerStatus() {
    if (this.physical_scaaner) {
      this._inputElement.nativeElement.focus();
    } else {
      this._lazy.loadScript("./assets/js/qr-code/qr-code.min.js").then((res) => {
        this._loadedLibraries['url'] = "./assets/js/qr-code/qr-code.min.js";
        this.checkCameraAfterScript$()
      })
    }
  }

  toggleVisibility(event: any) {
    const check = event.target.checked;
    this.physical_scaaner = check;
    this.preferenceService._saveCommonVoiceDetailsConfig('default_camera_scanner', check, ()=>{
      window.location.reload();
    });
    setTimeout(() => {
      this.checkscannerStatus();
    }, 2000);
  }

  onKey(event: any) {
    this.loader.showSpinner();
    if (event.key === "Enter") {
      this.loader.hideSpinner();
      this.closePopup(event.target.value)
    }
  }

  checkCameraAfterScript$() {
    var _that = this;
    this.util.detectWebcam((res: any) => {
      if (res) {
        this.checkCameraPermission((result: any) => {
          if (result == "prompt") {
            // this.closePopup()
            _that.util.checkCameraAccessStatus()
            _that.showCameraPopUp = true;
            _that.device = "camera"
          } else if (result == "denied") {
            // this.closePopup();
            _that.util.checkCameraAccessStatus()
            _that.device = "camera"
            _that.showCameraPopUp = true;
          } else {
            if(this.checkMobile()){
              this.facingModeIndex = 1;
            }
            this.getlistofCameras();
          }
        })
      } else {
        this.alert.error("No camera detected")
      }
    })
  }

  getlistofCameras() {
    navigator.mediaDevices.enumerateDevices().then(getVideoInputs => {
      var that = this;
      getVideoInputs.forEach(mediaDevice => {
        if (mediaDevice.kind === 'videoinput') {
          that.listOfCameras.push(mediaDevice);
        }
      });
      this.startQrCodeScanner(this.listOfCameras[this.facingModeIndex].deviceId)
    })
  }


  checkCameraPermission(callback) {
    var that = this;
    if (this.appService.checkNativeApp() || this.util.isiOS()) {
      callback(true);
    } else {
      const permissionName = "camera" as PermissionName;
      navigator.permissions.query({ name: permissionName }).then(function (permissionStatus) {
        if (permissionStatus.state == 'prompt' || permissionStatus.state == 'denied') {
          that.alert.error("Please give permission to access Camera");
          callback(permissionStatus.state)
        } else {
          callback(permissionStatus.state);
        }
      })
    }
  }

  checkMobile(){
    return this.util.isMobile()
  }

  closedevicePopup(event: any) {
    this.showCameraPopUp = false;
  }

  closePopup(event: any) {
    let _data = this.util.parseQrCodeString(event)
    if (!_data)
      this.alert.error("Applicable only for Aadhar card and ABHA health card Only");
    this.dialog.close(_data);
  }

  ngOnInit(): void {
     this.translate.transform("qrcsc").pipe(take(1)).subscribe((res:any)=>{
      if(res){
        this.placeholderValue = res;
      }
    }) 
    this.physical_scaaner = this.preferenceService.checkCommonConfigEnabled('default_camera_scanner')?this.preferenceService.checkCommonConfigEnabled('default_camera_scanner'): false;
  }


  ngOnDestroy(): void {
    let player: any = document.querySelector("#videoQRScanner");
    if (player && player.srcObject) {
      player.srcObject.getVideoTracks().forEach(track => track.stop())
      this.stopQrCodeScanning(()=>{})
    }
  }

  switchCamera(){
    this.facingModeIndex = this.facingModeIndex === 0? 1: 0;
    this.stopQrCodeScanning((res)=>{
      if(res){
        this.startQrCodeScanner(this.listOfCameras[this.facingModeIndex].deviceId)
      }else{

      }
    })
    
  }

  stopQrCodeScanning(cb) {
    this.html5QrcodeScanner.stop().then((ignore) => {cb(true) }).catch((err) => { cb(false)});
  }

  startQrCodeScanner(cameraId) {
    var that = this;
    this.html5QrcodeScanner = new Html5Qrcode("reader");
    this.html5QrcodeScanner.start(
      cameraId,
      {
        fps: 10,    // Optional, frame per seconds for qr code scanning
        qrbox: { width: 250, height: 250 }  // Optional, if you want bounded box UI
      },
      (decodedText, decodedResult) => {
        if (decodedText) {
          that.closePopup(decodedText)
        }
      })
  }

}
